const mapsPhotosLabelKey = "surveyDetail.sections.mapsPhotos";

export const surveyDetailRoutes = {
  site: {
    path: "maps/site",
    labelKey: "surveyDetail.sections.site",
    parentLabelKey: mapsPhotosLabelKey,
  },
  anomalies: {
    path: "maps/anomalies",
    labelKey: "surveyDetail.sections.anomalies",
    parentLabelKey: mapsPhotosLabelKey,
  },
  obstacles: {
    path: "maps/obstacles",
    labelKey: "surveyDetail.sections.obstacles",
    parentLabelKey: mapsPhotosLabelKey,
  },
  report: {
    path: "report",
    labelKey: "surveyDetail.sections.report",
  },
} as const;

export const surveyDetailRouteList = Object.values(surveyDetailRoutes);

export const surveyDetailNavigation = {
  mapsPhotos: {
    labelKey: mapsPhotosLabelKey,
    routes: [
      surveyDetailRoutes.site,
      surveyDetailRoutes.anomalies,
      surveyDetailRoutes.obstacles,
    ],
  },
  report: surveyDetailRoutes.report,
} as const;

export type SurveyDetailRoute = (typeof surveyDetailRouteList)[number];

export function getSurveyDetailPath(
  surveyUuid: string,
  route: SurveyDetailRoute,
) {
  return `/surveys/${encodeURIComponent(surveyUuid)}/${route.path}`;
}
